import React from "react";
import { Subscribe } from "unstated";
import { useTranslation } from "react-i18next";

import BackButtonIcon from "./BackButtonIcon";

import StateContainer from "../../../state/StateContainer";
import stringHelper from "../../../utils/helpers/stringHelper";

import "./BackButton.css";

function BackButton(props) {
  const { frameId, isApartmentPage } = props;

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  function etageClassName() {
    if (language === "German")
      return `${isApartmentPage
          ? "back-button__etage-sign etage-sign--german"
          : "back-button__etage-sign etage-sign--german etage-sign--apartment-mobile"
        }`;

    return `${isApartmentPage
        ? "back-button__etage-sign etage-sign--apartment-mobile"
        : "back-button__etage-sign"
      }`;
  }

  function etageNumberClassName() {
    if (language === "German")
      return `${isApartmentPage
          ? "back-button__etage-number etage-number--german etage-number--apartment-mobile"
          : "back-button__etage-number etage-number--german"
        }`;

    return `${isApartmentPage
        ? "back-button__etage-number etage-number--apartment-mobile"
        : "back-button__etage-number"
      }`;
  }

  function returnClassName() {
    if (language === "German")
      return `${isApartmentPage
          ? "back-button__return-sign return-sign--german return-sign--apartment-mobile"
          : "back-button__return-sign return-sign--german"
        }`;

    return `${isApartmentPage
        ? "back-button__return-sign return-sign--apartment-mobile "
        : "back-button__return-sign"
      }`;
  }

  function triggerSceneRender() {
    const event = new CustomEvent("sceneNeedsRender");
    let fullscreenNode = document.getElementById("full-screenable-node");
    fullscreenNode.dispatchEvent(event);
  }

  function clickHandler() {
    cancelAnimationFrame(frameId);
    triggerSceneRender();
    props.unstated.toggleApartmentInfoOff();
  }

  return (
    <div onClick={clickHandler} className="back-button">
      <BackButtonIcon isApartmentPage={isApartmentPage} />
      <div className="back-button__content">
        <div className="stage_wrapper"> 
          <p className={etageClassName()}>{t("STAGE").toUpperCase()} </p>
          <strong className={etageNumberClassName()}>
            {stringHelper.parseStateNumber(
              props.unstated.state.jsonData.states[
                props.unstated.state.currentState
              ].name
            )}
            &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;{" "}
          </strong>
        </div>
        <p className={returnClassName()}>
          {t("RETURN").toUpperCase()}&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;{" "}
        </p>
      </div>
    </div>
  );
}

function BackButtonWithUnstated(props) {
  return (
    <Subscribe to={[StateContainer]}>
      {(unstated) => <BackButton {...props} unstated={unstated} />}
    </Subscribe>
  );
}

export default BackButtonWithUnstated;
